var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"focusin":_setup.recordFocusedRail}},_vm._l((_setup.railsOnDisplay),function(rail,index){return _c(_setup.railComponents[rail.type],{key:rail.id,tag:"component",attrs:{"rail":rail,"railIndex":index,"railDidNavigateDown":_setup.railDidNavigateDown}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }